import React, { useState, useEffect } from "react";

import { Typography, Button, Space, Select } from "antd";
import ModalDetailAssignRiderZones from "./modalRiderVisibleZones";
import { userhasPermissionHelper } from "../../../../utils/Helpers";
import { PERMISSION_CONSTANT } from "../../../../utils/constants/app";
import { connect } from "react-redux";

const { Option } = Select;

const { Title } = Typography;
const RiderVisibleZones = (props) => {
  const [postDataRiderFilter, setPostDataRiderFilter] = useState(null);

  useEffect(() => {
    filterPostDataZone(props.postDataZoneList);
    filterPostDataRider(props.riderData);
  }, []);
  const filterPostDataRider = (values) => {
    values &&
      values.map((item) => {
        const postData = {
          riderId: item.id,
          zoneIds: filterPostDataRiderZone(item.zone),
          riderfullName: item.fullName,
        };
        setPostDataRiderFilter(postData);
      });
  };
  const filterPostDataRiderZone = (values) => {
    const zoneData = [];
    if (values != undefined && values.id != null) {
      values &&
        values.map((item) => {
          zoneData.push(item.id);
        });
      return zoneData;
    }
  };

  const [postDataZoneOption, setPostDataZoneOption] = useState(null);
  const filterPostDataZone = (values) => {
    const zoneData = [];
    values &&
      values.map((item) => {
        zoneData.push(<Option value={item.id}>{item.zoneName}</Option>);
      });
    setPostDataZoneOption(zoneData);
  };

  const [showModalAssignRiderZones, setshowModalAssignRiderZones] =
    useState(false);
  const showAssignRiderZonesModal = () => {
    setshowModalAssignRiderZones(true);
  };

  return (
    <div className="">
      <ModalDetailAssignRiderZones
        visible={showModalAssignRiderZones}
        setvisible={setshowModalAssignRiderZones}
        riderData={props.riderData}
        postDataZoneList={props.postDataZoneList}
        postDataRiderFilter={postDataRiderFilter}
        postDataZoneOption={postDataZoneOption}
        VisibleZoneData={props.VisibleZoneData}
        postListsrefresh={props.postListsrefresh}
        // zoneData={zoneData}
      />
      <Space direction="vertical">
        <Space direction="horizontal">
          <Title level={5}>Zones</Title>
          {
            userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_ZONES_ASSIGNMENT) &&
              <Button onClick={showAssignRiderZonesModal}>Edit Visible Zone</Button>
          }
        </Space>
        <span>
          <div className="krflex krbadge">{props.VisibleZoneData}</div>
        </span>
      </Space>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderVisibleZones);
